import { takeLatest } from 'redux-saga/effects';
import sagaActions from '../../actions/index';
import { getTaxSaga, setTaxSaga } from './taxSaga';

export function* taxSaga() {
  yield takeLatest(sagaActions.GET_TAX_SETTING, getTaxSaga);
  yield takeLatest(sagaActions.UPDATE_TAX_SETTING, setTaxSaga);
}
